module.exports = __webpack_public_path__ + "img/undraw_profile_edit.592e50a4.svg";